import { SITE_API } from '../settings';

export async function postEmailForTranscript({
  email,
  referrer,
  token,
}: {
  email: string;
  referrer?: string;
  token: string;
}): Promise<unknown> {
  const url = `${SITE_API}/results/${token}/email_transcript/`;

  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      email: email,
      referrer: referrer,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (res?.status === 201) {
    return res?.statusText || 'Email submitted';
  }
}

export function submitEmailForTranscript({
  email,
  referrer,
  token,
}: {
  email: string;
  referrer?: string;
  token: string;
}) {
  postEmailForTranscript({ email, referrer, token });
}
